import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

const DynamicTable = ({
  addEmptyRow,
  children: rows,
  headers,
  addButtonDescription,
  disableAddButton: disabled,
}) => {
  const addButtonClassNames = classNames({
    disabled,
  });
  return (
    <div className="DynamicTable">
      <div className="table-controls">
        <Button
          className={addButtonClassNames}
          bsStyle={"primary"}
          onClick={addEmptyRow}
        >
          <FormattedMessage id="common.add" />
        </Button>
        {addButtonDescription}
      </div>
      <table>
        <thead>
          <tr>
            {headers &&
              headers.map((headerName, index) => (
                <th key={index}>{headerName}</th>
              ))}
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
};

DynamicTable.propTypes = {
  disabled: PropTypes.bool,
  children: PropTypes.array,
  readonly: PropTypes.bool,
  addEmptyRow: PropTypes.func,
  headers: PropTypes.array,
  addButtonDescription: PropTypes.object,
  disableAddButton: PropTypes.bool,
};

export default DynamicTable;



// WEBPACK FOOTER //
// ./src/components/common/form/DynamicTable.js